import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from '../../components/ui/Feedback';
import { useAuth } from './AuthProvider';

/**
 * Layout route that guards every application screen.
 *
 * While the stored token is being verified it renders the splash instead of the
 * login form, so a page reload does not flash the sign-in screen.
 */
export function RequireAuth() {
  const { user, initializing } = useAuth();
  const location = useLocation();

  if (initializing) {
    return (
      <div className="auth-splash">
        <Spinner label="Checking your session" />
      </div>
    );
  }

  if (!user) {
    // Remember the attempted URL so sign-in can return the user to it.
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <Outlet />;
}
